<template>
    <div>
        <gofix-card title=" " classHeader="mb-2" classContent="position-relative pr-83">
            <b-row class="mb-16">
                <b-col md="4">
                    <gofix-text-field label="Permit Applicant" oneline>{{ Item.created_by_user && Item.created_by_user.name ? Item.created_by_user.name : '' }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field label="PTW Type" oneline>{{ Item.type }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field classInner="justify-content-end" label="Status" oneline>{{ Item.status }}</gofix-text-field>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="4">
                    <gofix-text-field label="Start Date" oneline>{{ Item.started_date ? $options.filters.formatDatebyMoment(Item.started_date, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field label="End Date" oneline>{{ Item.expiry_date ? $options.filters.formatDatebyMoment(Item.expiry_date, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                </b-col>
                
            </b-row>
            <b-row class="mb-16">
                <!-- <b-col md="5">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Submitted Date" oneline>{{ Item.submitted_at ? $options.filters.formatDatebyMoment(Item.submitted_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Submitted By" oneline>{{ Item.submitted_by && Item.submitted_by.name ? Item.submitted_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col> -->
                <b-col md="12">
                    <b-row>
                        <b-col md="4">
                            <gofix-text-field label="Project Name" oneline>{{ Item.project && Item.project.contract_title ? Item.project.contract_title : '' }}</gofix-text-field>
                        </b-col>
                        <b-col md="4">
                            <gofix-text-field label="Assessor" oneline>
                                {{ Item.assesor_by && Item.assesor_by.name ? Item.assesor_by.name : '' }}
                                <span v-if="isAllowEditSA" style="" @click="handleShowSafetyAssessor" class="mr-2 mb-2 cursor-pointer">
                            <img src="img/iconPencil.png" alt="edit-comment" with="18px" height="18">
                        </span>
                            </gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row>
            <!-- <b-row class="mb-16">
                <b-col md="5">
                    <b-row v-if="!Item.related_id">
                        <b-col md="6">
                            <gofix-text-field label="Completed Date" oneline>{{ Item.completed_at ? $options.filters.formatDatebyMoment(Item.completed_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Completed By" oneline>{{ Item.completed_by && Item.completed_by.name ? Item.completed_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                    <b-row v-else>
                        <b-col md="6">
                            <gofix-text-field label="Pending Approval Date" oneline>{{ Item.pending_approval_at ? $options.filters.formatDatebyMoment(Item.pending_approval_at, "YYYY-MM-DD HH:mm:ss","DD.MM.YYYY HH:mm") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Pending Approval By" oneline>{{ Item.pending_approval_by && Item.pending_approval_by.name ? Item.pending_approval_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
                <b-col md="7">
                    <b-row>
                        <b-col md="12">
                            <gofix-text-field label="Assesor" oneline>{{ Item.assesor_by && Item.assesor_by.name ? Item.assesor_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row> -->
            <!-- <b-row class="mb-16">
                <b-col md="5" v-if="Item.related_id">
                    <b-row>
                        <b-col md="6">
                            <gofix-text-field label="Approved Date" oneline>{{ Item.approved_at ? $options.filters.formatDatebyMoment(Item.approved_at, "YYYY-MM-DD","DD.MM.YYYY") : "n/a" }}</gofix-text-field>
                        </b-col>
                        <b-col md="6">
                            <gofix-text-field label="Approved By" oneline>{{ Item.approved_by && Item.approved_by.name ? Item.approved_by.name : '' }}</gofix-text-field>
                        </b-col>
                    </b-row>
                </b-col>
            </b-row> -->
            <b-row class="mb-16">
                <b-col md="4">
                    <gofix-text-field label="Number of Supervisor" oneline>{{ Item.number_of_supervisor ? Item.number_of_supervisor : 0 }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field label="Project Manager" oneline>
                        {{ Item.project_manager_by && Item.project_manager_by.name ? Item.project_manager_by.name : '' }}
                        <span v-if="isAllowEditPM" style="" @click="handleShowProjectManager" class="mr-2 mb-2 cursor-pointer">
                            <img src="img/iconPencil.png" alt="edit-comment" with="18px" height="18">
                        </span>
                    </gofix-text-field>
                </b-col>
            </b-row>
            <b-row class="mb-16">
                <b-col md="4">
                    <gofix-text-field label="Number of Workmen" oneline>{{ Item.number_of_workmen ? Item.number_of_workmen : 0 }}</gofix-text-field>
                </b-col>
                <b-col md="4">
                    <gofix-text-field label="Location" oneline>{{ Item.location }} {{ Item.equipment_type }} {{ Item.equipment_lift_number }}</gofix-text-field>
                </b-col>
            </b-row>
            <b-row>
                <b-col md="12" class="mb-16">
                    <gofix-text-field label="Geo Fencing" oneline>
                        <b-button class="ml-2 p-0 bg-transparent border-0 goFixLocationButton" title="Geo Coordinates" v-b-tooltip.hover @click="showGeoLocation">
                            <i class="icon-location-pin color-orange font-weight-bolder"></i>
                        </b-button>
                    </gofix-text-field>
                </b-col>
                <b-col md="12">
                    <gofix-text-field label="Description of Work" oneline>
                        <span v-html="Item.description ? Item.description.replaceAll('\n', '<br>') : ''"></span>
                    </gofix-text-field>
                </b-col>
            </b-row>
            <!-- <span v-if="isChangeStatus" style="top: 0 !important; right: 31px !important;" @click="editBacsicInfo" class="editBox position-absolute cursor-pointer">
                <img src="img/iconPencil.png" alt="edit bacsic info" with="18px" height="18">
            </span> -->
        </gofix-card>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Actions" hide-footer :centered="true" v-model="modals.bacsicInfo.open">
            <b-form class="pb-10">
                <!-- <b-row class="mb-10">
                    <b-col md="12">
                         <gofix-text-field class="mb-10" label="Project Name" oneline>{{ Item.project_id }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class="mb-10" label="Contractor Company" oneline>{{ Item.supplier }}</gofix-text-field>
                    </b-col>
                    <b-col md="12">
                        <gofix-text-field class="mb-10" label="Location"  oneline>{{ Item.properties && Item.properties.name ? Item.properties.name : '' }}</gofix-text-field>
                    </b-col>
                </b-row>
                <br /> -->
                <template>
                    <gofix-form-dropdown 
                        label="Status" 
                        vLabel="name" 
                        :disabled="modals.bacsicInfo.options.status.length == 0"
                        :filterable="false" 
                        v-model="modals.bacsicInfo.data.status" 
                        :options="jobOptionStatus">
                    </gofix-form-dropdown>
                    <dropdown-user-duties 
                        v-if="job.status == 'New'"
                        label="Submitted By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        :company-id="Item.supplier && Item.supplier.id ? Item.supplier.id : null"
                        :reduce="option => option.user_id"
                        role-name="Contractor Supervisor"
                        v-model="modals.bacsicInfo.data.submitted_by_id">
                    </dropdown-user-duties>
                    <!-- <dropdown-user-duties 
                        v-if="Item.status == 'Submitted' && !Item.related_id"
                        label="Completed By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        role-name="Safety Assessor"
                        :safetyOnlyFM="true"
                        :reduce="option => option.user_id"
                        v-model="modals.bacsicInfo.data.completed_by_id">
                    </dropdown-user-duties> -->
                    <dropdown-user-duties 
                        v-if="modals.bacsicInfo.data.status == 'Approved'"
                        label="Approved By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        role-name="Project Manager"
                        :reduce="option => option.user_id"
                        v-model="modals.bacsicInfo.data.approved_by_id">
                    </dropdown-user-duties>
                    <dropdown-user-duties 
                        v-if="modals.bacsicInfo.data.status == 'Pending Approval' && job.related_id"
                        label="Pending Approval By"
                        :project-id="Item.project && Item.project.id ? Item.project.id : null"
                        role-name="Safety Assessor"
                        :reduce="option => option.user_id"
                        v-model="modals.bacsicInfo.data.pending_approval_by_id">
                    </dropdown-user-duties>
                    <b-row v-if="job.status == 'New'">
                        <b-col md="6">
                            <gofix-form-input-date :minDate="new Date()" v-model="modals.bacsicInfo.data.submitted_at" label="Submitted Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Submitted Time" v-model="modals.bacsicInfo.data.submitted_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <!-- <b-row v-if="Item.status == 'Submitted' && !Item.related_id">
                        <b-col md="6">
                            <gofix-form-input-date v-model="modals.bacsicInfo.data.completed_at" label="Completed Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Completed Time" v-model="modals.bacsicInfo.data.completed_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row> -->
                    <b-row v-if="modals.bacsicInfo.data.status == 'Approved'">
                        <b-col md="6">
                            <gofix-form-input-date :minDate="new Date()" v-model="modals.bacsicInfo.data.approved_at" label="Approved Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Approved Time" v-model="modals.bacsicInfo.data.approved_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                    <b-row v-if="modals.bacsicInfo.data.status == 'Pending Approval' && job.related_id">
                        <b-col md="6">
                            <gofix-form-input-date :minDate="new Date()" v-model="modals.bacsicInfo.data.pending_approval_at" label="Pending Approval Date"></gofix-form-input-date>
                        </b-col>
                        <b-col md="6">
                            <gofix-form-input-time label="Pending Approval Time" v-model="modals.bacsicInfo.data.pending_approval_at_hour"></gofix-form-input-time>
                        </b-col>
                    </b-row>
                </template>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="updateBasicInfo" :loading="modals.bacsicInfo.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-bacsicInfo" title="Edit Project Manager" hide-footer :centered="true" v-model="modals.projectManager.open">
            <b-form class="pb-10">
                <dropdown-user-duties 
                    label="Project Manager"
                    required
                    show-icon-required
                    :project-id="Item.project_id ? Item.project_id : null"
                    role-name="Project Manager"
                    v-model="modals.projectManager.data.project_manager">
                </dropdown-user-duties>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="handleSaveProjectManager" :loading="modals.projectManager.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
        <b-modal :no-close-on-backdrop="true" id="modal-safetyAssessor" title="Edit Safety Assessor" hide-footer :centered="true" header-class="border-0 pb-2" content-class="rounded-0" v-model="modals.safetyAssessor.open">
            <b-form class="pb-10">
                <dropdown-user-duties 
                    label="Assessor"
                    required
                    show-icon-required
                    :project-id="Item.project_id ? Item.project_id : null"
                    role-name="Safety Assessor"
                    v-model="modals.safetyAssessor.data.assesor_by">
                </dropdown-user-duties>
            </b-form>
            <b-button-group class="d-block text-right">
                <gofix-button label="APPLY" @click="handleSaveSafetyAssessor" :loading="modals.safetyAssessor.loading" noBorder></gofix-button>
            </b-button-group>
        </b-modal>
    </div>
</template>
<script>
    import { mapGetters } from 'vuex';
    import moment from 'moment';
    import DropdownUserDuties from '../elements/DropdownUserDuties.vue'
    export default {
        name: 'permit-to-work-detail-info',
        components: {
            DropdownUserDuties
        },
        props: {
            job: {
                type: Object,
                default: () => ({})
            },
            checklistEntries: {
                type: Array,
                default: () => []
            },
            onClickShowGeo: {
                type: Function,
            }
        },
        data() {
            return {
                modals: {
                    bacsicInfo: {
                        open: false,
                        loading: false,
                        data: {
                            status: null,
                            completed_by_id: null,
                            approved_by_id: null,
                            submitted_by_id: null,
                            submitted_at: null,
                            submitted_at_hour: null,
                            approved_at: null,
                            approved_at_hour: null,
                            completed_at: null,
                            completed_at_hour: null,
                            pending_approval_by_id: null,
                            pending_approval_at: null,
                            pending_approval_at_hour: null,
                        },
                        options: {
                            status: ['Submitted', 'Approved', 'Pending Approval', 'Closed']
                        }
                    },
                    projectManager: {
                        open: false,
                        loading: false,
                        data: {
                            project_manager: null
                        }
                    },
                    safetyAssessor: {
                        open: false,
                        loading: false,
                        data: {
                            assesor_by: null
                        }
                    }
                },
                option_status: {
                    'New': ['Submitted'],
                    'Submitted': ['Pending Approval', 'Rejected', 'Closed'],
                    'Pending Approval': ['Approved', 'Rejected', 'Closed'],     
                    'Approved': ['Rejected', 'Closed'],            
                },
                timer: {
                    saveProjectManager: null,
                    saveSafetyAssessor: null,
                }
            }
        },
        computed: {
            ...mapGetters({
                User : 'AuthController/user',
                Item: 'SafetyAppController/safetyJob',
            }),
            jobOptionStatus() {
                let options = this.option_status[this.job.status];
                // if(this.Item.related_id && this.Item.status == 'Submitted') {
                //     options = ['Pending Approval'];
                    
                // }
                if(this.Item && this.Item.status && ['Approved'].includes(this.Item.status)) {
                    let today = moment().format("YYYY-MM-DD");
                    if(this.Item && this.Item.expiry_date && moment(today).isAfter(moment(this.Item.expiry_date).format("YYYY-MM-DD"))) {
                       options = ['Closed'];
                    }
                }

                return options;
            },
            isChangeStatus() {
                if(!this.$checkRole(this.$accessModule.permit_to_work, 'update')) return false;
                return true;
                // return this.Item && ((this.Item.related_id == null && this.Item.status == 'New') || (
                //     this.Item.related_id != null && (this.Item.status != 'New' && this.Item.status != 'Approved') && (this.Item.planned_date && new Date(this.Item.planned_date).toDateString() === new Date().toDateString())
                // ));
            },
            isAllowEditPM() {
                if(this.Item.status == 'New' || this.Item.status == 'Submitted' || this.Item.status == 'Pending Approval') {
                    let today = moment().format("YYYY-MM-DD");
                    if(this.Item && this.Item.expiry_date && moment(today).isAfter(moment(this.Item.expiry_date).format("YYYY-MM-DD"))) {
                        return false;
                    }
                    return this.User.roles.some(item => item.name.trim().toLowerCase() === 'safety app administrator');
                }
                return false;
            },
            isAllowEditSA() {
                if(this.Item.status == 'New' || this.Item.status == 'Submitted') {
                    let today = moment().format("YYYY-MM-DD");
                    if(this.Item && this.Item.expiry_date && moment(today).isAfter(moment(this.Item.expiry_date).format("YYYY-MM-DD"))) {
                        return false;
                    }
                    return this.User.roles.some(item => item.name.trim().toLowerCase() === 'safety app administrator');
                }
                return false;
            }
        },
        created() {
            
        },
        methods: {
            /*-- Get Data --------*/
            editBacsicInfo() {
                this.modals.bacsicInfo.data = Object.assign(this.modals.bacsicInfo.data, {
                    status: null,
                    completed_by_id: this.job.completed_by_id,
                    approved_by_id: this.job.approved_by_id,
                    submitted_by_id: this.job.submitted_by_id,
                    submitted_at: this.job.submitted_at ? new Date(this.job.submitted_at) : null,
                    submitted_at_hour: this.job.submitted_at ? moment(new Date(this.job.submitted_at)).format("HH:mm") : null,
                    approved_at: this.job.approved_at ? new Date(this.job.approved_at) : null,
                    approved_at_hour: this.job.approved_at ? moment(new Date(this.job.approved_at)).format("HH:mm") : null,
                    pending_approval_by_id: this.job.pending_approval_by_id,
                    pending_approval_at: this.job.pending_approval_at ? new Date(this.job.pending_approval_at) : null,
                    pending_approval_at_hour: this.job.pending_approval_at ? new Date(this.job.pending_approval_at) : null,
                });
                this.modals.bacsicInfo.open = true;
            },
            updateBasicInfo() {
                if(!this.modals.bacsicInfo.data.status) {
                    return this.$alertNotification("Please select status", "danger");
                }

                let params = this.processJob(this.modals.bacsicInfo.data);
                if(params === false) return

                if (this.modals.bacsicInfo.loading) return;
                this.modals.bacsicInfo.loading = true;

                /* All checklists need to be ticked */
                let flagChecklist = false;
                if((this.job.related_id == null && this.job.status == 'New') || (this.job.related_id != null && this.job.status == 'Submitted' && this.modals.bacsicInfo.data.status == 'Pending Approval')) {
                    for(let i = 0; i < this.checklistEntries.length; i++) {
                        const item = this.checklistEntries[i];
                        if(item.children && item.children.length > 0) {
                            for(let j = 0; j < item.children.length; j++) {
                                const child = item.children[j];
                                if(child.safety_checklist_entries && child.safety_checklist_entries.length) {
                                    for(let k = 0; k < child.safety_checklist_entries.length; k++) {
                                        const entry = child.safety_checklist_entries[k];
                                        if(entry.input.value === false && entry.status == 'Unfilled') {
                                            flagChecklist = true;
                                            break;
                                        }
                                    }
                                }
                            }
                        }

                        if(item.safety_checklist_entries && item.safety_checklist_entries.length) {
                            for(let k = 0; k < item.safety_checklist_entries.length; k++) {
                                const entry = item.safety_checklist_entries[k];
                                if(entry.input.value === false && entry.status == 'Unfilled') {
                                    flagChecklist = true;
                                    break;
                                }
                            }
                        }

                        if(flagChecklist) break;
                    }
                }

                if(flagChecklist) {
                    this.modals.bacsicInfo.loading = false;
                    return this.$alertNotification("Please fill all checklist items before submit", "danger");
                }

                let job_id = this.job.id;
                if(params.status == 'Closed') {
                    job_id = this.Item.id;
                }

                this.$store
                    .dispatch("SafetyAppController/updateSafetyStatus", {
                        data: params,
                        id: job_id,
                    })
                    .then((result) => {
                        this.$alertNotification(this.$notificationV2("editing", "permit_to_work"));
                        // this.is_open_signature = false;
                        this.modals.bacsicInfo.loading = false;
                        this.modals.bacsicInfo.open = false;
                        this.$emit("reloadItem");
                    })
                    .catch((err) => {
                        this.modals.bacsicInfo.loading = false;
                        if(err.response.data.error.message.error){
                            return this.$alertNotification(err.response.data.error.message.error, "danger");
                        }
                    });
            },
            processJob(data) {
                let status = data.status.toLowerCase();
                if(status == 'pending approval') status = 'pending_approval';
                const defaultStatus = {
                    'submitted': {
                        status: 'Submitted',
                        submitted_by_id: data.submitted_by_id || null,
                        submitted_at: null,
                    },
                    'approved': {
                        status: 'Approved',
                        approved_by_id: data.approved_by_id || null,
                        approved_at: null,
                    },
                    'pending_approval': {
                        status: 'Pending Approval',
                        pending_approval_by_id: data.pending_approval_by_id || null,
                        pending_approval_at: null,
                    },
                    'rejected': {
                        status: 'Rejected',
                        rejected_by_id: this.User.id,
                        rejected_at: moment(new Date()).format("YYYY-MM-DD HH:mm:ss"),
                        activity_remark: ''
                    },
                    'closed': {
                        status: 'Closed',
                    }
                };
                

                const obj = defaultStatus[status];
                if(status == 'closed') {
                    return obj
                }

                if(!obj[`${status}_by_id`]) {
                    this.$alertNotification(`Please select ${obj.status} By`, "danger");
                    return false
                }

                if (data[`${status}_at`]) {
                    const dateValue = moment(new Date(data[`${status}_at`]));
                    if (!dateValue.isSame(moment(), 'day')) {
                        this.$alertNotification(`${obj.status} Date must be today`, "danger");
                        return false;
                    }
                    obj[`${status}_at`] = dateValue.format("YYYY-MM-DD");
                }

                if (data[`${status}_at_hour`]) {
                    obj[`${status}_at`] = obj[`${status}_at`] + ' ' + data[`${status}_at_hour`] + ":00";
                }

                return obj
            },
            handleShowProjectManager() {
                this.modals.projectManager.data.project_manager = this.Item.project_manager_by && this.Item.project_manager_by.id ? {
                    user_id: this.Item.project_manager_by.id, 
                    user_name: this.Item.project_manager_by.name, 
                    user_email: this.Item.project_manager_by.email,
                    id: this.Item.project_manager_by.id
                } : null;
                this.modals.projectManager.open = true;
            },
            handleSaveProjectManager() {
                if (this.timer.saveProjectManager) {
                    clearTimeout(this.timer.saveProjectManager);
                    this.timer.saveProjectManager = null;
                }
                this.timer.saveProjectManager = setTimeout(async () => {

                    const validate_fields = [
                        { key: 'project_manager', name: 'Project Manager'}
                    ]

                    const is_validate = this.$validationData(validate_fields, this.modals.projectManager.data)
                    if(is_validate) return

                    if(this.modals.projectManager.loading) return;
                    this.modals.projectManager.loading = true;

                    let params = {
                        id: this.Item.id,
                        data: {
                            project_manager_id: this.modals.projectManager.data.project_manager ? this.modals.projectManager.data.project_manager.user_id : null,
                            location: this.Item.location,
                            location_id: this.Item.location_id,
                            type: this.Item.type,
                            project_id: this.Item.project_id,
                            started_date: this.Item.started_date,
                            expiry_date: this.Item.expiry_date,
                        }
                    };
                    
                    this.$store.dispatch("SafetyAppController/updatePermitToWorkItem", params)
                    .then(async response => {
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.modals.projectManager.open = false;
                        this.$emit("reloadItem");
                        this.$alertNotification(this.$notificationV2('editing', 'permit_to_work'), "success");
                    })
                    .catch(err => {
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    }).finally(() => {
                        this.modals.projectManager.loading = false;
                    });

                }, 200);
            },
            handleShowSafetyAssessor() {
                this.modals.safetyAssessor.data.assesor_by = this.Item.assesor_by && this.Item.assesor_by.id ? {
                    user_id: this.Item.assesor_by.id, 
                    user_name: this.Item.assesor_by.name, 
                    user_email: this.Item.assesor_by.email,
                    id: this.Item.assesor_by.id
                } : null;
                this.modals.safetyAssessor.open = true;
            },
            handleSaveSafetyAssessor() {
                if (this.timer.saveSafetyAssessor) {
                    clearTimeout(this.timer.saveSafetyAssessor);
                    this.timer.saveSafetyAssessor = null;
                }
                this.timer.saveSafetyAssessor = setTimeout(async () => {

                    const validate_fields = [
                        { key: 'assesor_by', name: 'Safety Assessor'}
                    ]

                    const is_validate = this.$validationData(validate_fields, this.modals.safetyAssessor.data)
                    if(is_validate) return

                    if(this.modals.safetyAssessor.loading) return;
                    this.modals.safetyAssessor.loading = true;

                    let params = {
                        id: this.Item.id,
                        data: {
                            assesor_id: this.modals.safetyAssessor.data.assesor_by ? this.modals.safetyAssessor.data.assesor_by.user_id : null,
                            location: this.Item.location,
                            location_id: this.Item.location_id,
                            type: this.Item.type,
                            project_id: this.Item.project_id,
                            started_date: this.Item.started_date,
                            expiry_date: this.Item.expiry_date,
                        }
                    };
                    
                    this.$store.dispatch("SafetyAppController/updatePermitToWorkItem", params)
                    .then(async response => {
                        if(response.code && response.message) {
                            this.$alertNotification(response.message, "danger");
                            return;
                        }
                        this.modals.safetyAssessor.open = false;
                        this.$emit("reloadItem");
                        this.$alertNotification(this.$notificationV2('editing', 'permit_to_work'), "success");
                    })
                    .catch(err => {
                        if( err.response.data.error && err.response.data.error.message ) {
                            this.$alertNotification(err.response.data.error.message, "danger"); 
                        }
                    }).finally(() => {
                        this.modals.safetyAssessor.loading = false;
                    });

                }, 200);
            },
            showGeoLocation() {
                this.onClickShowGeo(this.Item.id, 'Submitted');
            }
        }
    }
</script>